import { RevEmptyState, RevSpinner } from "@revmatics/catalyst";
import { StepInterestGroupSelectProps } from "../CreateBriefTypes.ts";

export const StepInterestGroupSelect: React.FC<
  StepInterestGroupSelectProps
> = ({
  interestGroups,
  selectedInterestGroupId,
  onSelectInterestGroup,
  isLoading,
  error,
}) => {
  if (isLoading) {
    return <RevSpinner size="large" centered />;
  }

  if (interestGroups.length === 0) {
    return (
      <RevEmptyState
        title="No Interest Groups Available"
        text="Interest group data may not be available for the selected persona."
      />
    );
  }

  return (
    <div>
      <p className="typography-body-sm mb-2">Select Interest Group</p>
      <div className="px-2 border-monochrome-200 bg-monochrome-50 border rounded-lg max-h-[65dvh] lg:h-[150px] overflow-y-auto scroll-vertical">
        {interestGroups.map((group) => {
          const isSelected = selectedInterestGroupId === group.id.toString();
          return (
            <button
              key={group.id}
              onClick={() => onSelectInterestGroup(group.id.toString())}
              className={`w-full my-2 bg-white rounded-lg p-2  ${isSelected ? "outline-2 outline-primary-500" : "outline-1 outline-monochrome-200 hover:outline-primary-500"}`}
            >
              <div className="flex flex-col text-left items-start">
                <h6 className="mb-2">{group.name}</h6>
              </div>
            </button>
          );
        })}
      </div>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
    </div>
  );
};
